import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { PanelSection } from '../../DispatchPanel'
import UserDetails from '../../../UserDetails'
import DataTable, { Row, RowData } from '../../../DataTable'
import { useDispatchData } from '../../DispatchDataWrapper'
import { auth, db } from '../../../../firebase'
import { doc, getDoc } from 'firebase/firestore'
import { useRest } from '../../../../hooks/api'
import { TrackService } from '../../../../services/TrackService'

function displayAvailability(status) {
  // Handle cases where status might be undefined or null
  if (status === true) return 'On-Duty'
  if (status === false) return 'Off-Duty'
  return 'Unknown' // Fallback for unexpected values
}

function TableRow({
  user,
  openDetails,
  setMapCenter,
  deviceLocationsByUserId
}) {
  const displayName =
    user.displayName || user.personalData[0]?.value || `User ${user.id}`

  const loc = deviceLocationsByUserId[user.id]

  return (
    <Row>
      <RowData style={{ cursor: 'pointer' }} onClick={() => openDetails(user)}>
        {displayName}
      </RowData>
      <RowData>{displayAvailability(user.dutyStatus)}</RowData>
      <RowData>
        <i
          title={!loc && 'Location data not available'}
          className='fa fa-map-marker-alt'
          style={{
            cursor: loc ? 'pointer' : 'default',
            fontSize: '1.25rem',
            opacity: loc ? 1.0 : 0.25
          }}
          onClick={() => loc && setMapCenter({ lng: loc[0], lat: loc[1] })}
        />
      </RowData>
    </Row>
  )
}

const COLUMNS = ['Name', 'Status', 'Location']

export default function ({ availableUnits, openSecondaryPanel, setMapCenter, mergedDeviceLocations = {} }) {
  const [myOrgId, setMyOrgId] = useState(null)

  const users = Object.values(availableUnits)
  console.log("users is here :::>>><<<", users)

  // 🔑 Get current user org from Firestore
  useEffect(() => {
    const fetchOrg = async () => {
      const uid = auth.currentUser?.uid
      if (!uid) return

      const userRef = doc(db, 'users', uid)
      const snap = await getDoc(userRef)
      if (snap.exists()) {
        const userData = snap.data()
        setMyOrgId(userData?.organization?.id || null)
      }
    }
    fetchOrg()
  }, [])

  // ✅ Filter users only from my organization
  const orgUsers = useMemo(
    () =>
      myOrgId ? users.filter((user) => user.organization?.id === myOrgId) : [],
    [users, myOrgId]
  )

  // const orgUsers = users.filter((user) => user.organization?.id === organizationId)
  // More robust filtering - handle cases where dutyStatus might be undefined
  const onDuty = orgUsers.filter((user) => user.dutyStatus === true)
  const offDuty = orgUsers.filter((user) => user.dutyStatus === false)




  const deviceLocationsByUserId = useMemo(() => {
    if (!mergedDeviceLocations) return {}

    return Object.values(mergedDeviceLocations).reduce((acc, item) => {
      if (!item?.user?.id || !item?.loc) return acc
      acc[item.user.id] = item.loc
      return acc
    }, {})
  }, [mergedDeviceLocations])



  const openDetails = useCallback(
    (user) =>
      openSecondaryPanel(
        <UserDetails id={user.id} />,
        user.personalData?.displayName?.value || `User #${user.id}`
      ),
    [openSecondaryPanel]
  )

  return (
    <div style={{ width: '100%' }}>
      <PanelSection title='On-Duty' bodyStyle={{ padding: 0 }}>
        <DataTable
          columns={COLUMNS}
          style={{ fontSize: '0.9rem' }}
          className='is-fullwidth'>
          {onDuty.map((user) => (
            <TableRow
              key={user.id}
              user={user}
              openDetails={openDetails}
              setMapCenter={setMapCenter}
              deviceLocationsByUserId={deviceLocationsByUserId}
            />
          ))}
        </DataTable>
      </PanelSection>
      <PanelSection title='Off-Duty' bodyStyle={{ padding: 0 }}>
        <DataTable
          columns={COLUMNS}
          style={{ fontSize: '0.9rem' }}
          className='is-fullwidth'>
          {offDuty.map((user) => (
            <TableRow
              key={user.id}
              user={user}
              openDetails={openDetails}
              setMapCenter={setMapCenter}
              deviceLocationsByUserId={deviceLocationsByUserId}
            />
          ))}
        </DataTable>
      </PanelSection>
    </div>
  )
}
